module.exports = __webpack_public_path__ + "static/img/14.5051f5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/14.png
// module id = xngs
// module chunks = 0